export default "__VITE_ASSET__Z3n8fNSE__"